import { Button } from "Components/Button";
import { ScheduleListAPIData } from "Requests/SchedulePartners";
import { Eye } from "lucide-react";

interface OrderListItemProps {
  order: ScheduleListAPIData;
  onSelectOrderId: () => void;
}

export const OrderListItem = ({
  order,
  onSelectOrderId,
}: OrderListItemProps) => {
  const { acuity_id, appointment_at, email, full_name, id } = order;

  let dateSchedule = "";
  let timeSchedule = "";

  if (appointment_at) {
    const [date, time] = appointment_at.split(" ");
    const [y, m, d] = date.split("-");
    timeSchedule = time.slice(0, 5);
    dateSchedule = `${d}/${m}/${y}`;
  }

  return (
    <tr>
      <td>{acuity_id}</td>
      <td>{full_name}</td>
      <td>{email}</td>
      <td>{dateSchedule || "Não informado"}</td>
      <td>{timeSchedule || "Não informado"}</td>
      <td>
        <Button textButton onClick={onSelectOrderId}>
          <Eye color="purple" />
        </Button>
      </td>
    </tr>
  );
};
